module.exports = __webpack_public_path__ + "img/5.ede0f1d7.png";